import React from 'react';
import EmailWriterApp from './EmailWriterApp';
import './App.css';

function App() {
    return (
        <div className="App">
            <EmailWriterApp />
        </div>
    );
}

export default App;